import gql from 'graphql-tag'

const REDIRECTED_RESOURCE_QUERY = gql`
  query RedirectedResourceQuery(
    $applicationId: String!
    $sourceType: String!
    $sourceId: String!
  ) {
    redirectedResource(
      applicationId: $applicationId
      sourceType: $sourceType
      sourceId: $sourceId
    ) {
      id
      type
      __typename
    }
  }
`

export default REDIRECTED_RESOURCE_QUERY



// WEBPACK FOOTER //
// ./src/routes/redirect.query.js